import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

export default function AdvancedSection({ children, id }) {
    const [open, setOpen] = React.useState(false);

    return (
        <Box>
            <Box
                onClick={() => setOpen(!open)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    mt: 2,
                    cursor: 'pointer',
                    userSelect: 'none',
                    '&:hover': { '& .adv-label': { color: '#7A7A7A' } },
                }}
            >
                <Box
                    component="svg"
                    width={12}
                    height={12}
                    viewBox="0 0 12 12"
                    fill="none"
                    sx={{
                        transition: 'transform 0.2s',
                        transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
                    }}
                >
                    <path
                        d="M4 2l4 4-4 4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Box>
                <Typography
                    className="adv-label"
                    sx={{
                        fontSize: 12.5,
                        fontWeight: 600,
                        color: '#B0B0B0',
                        transition: 'color 0.15s',
                    }}
                >
                    {open ? 'Hide advanced options' : 'Advanced options'}
                </Typography>
            </Box>
            {open && (
                <Box
                    id={id}
                    sx={{
                        mt: 1.75,
                        p: 2,
                        backgroundColor: '#F7F7F7',
                        borderRadius: '16px',
                        border: '1px solid #EBEBEB',
                    }}
                >
                    {children}
                </Box>
            )}
        </Box>
    );
}

AdvancedSection.propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.string,
};

AdvancedSection.defaultProps = {
    id: undefined,
};
